import './css/common.css'
import './css/app.css'
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from "react-router-dom"
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import { useDispatch, useSelector } from 'react-redux';
import { change_MyData } from '../store';
import { QRCodeCanvas } from 'qrcode.react';
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import { Copy } from 'lucide-react';

function Login() {
    let navigate = useNavigate();
    let dispatch = useDispatch();

    const hostLogoImg = useSelector((state) => state.hostLogoImg.value);

    const [id, setId] = useState("")
    const [password, setPassword] = useState("")
    const [saveId, setSaveId] = useState(false)
    const [message, setMessage] = useState("")
    const [modal, setModal] = useState(false)
    const [reload, setReload] = useState(false)
    const [otpData, setOtpData] = useState([])
    const [otpState, setOtpState] = useState(true)

    const onChangeId = (e) => {
        setId(e.target.value)
    }

    const onChangePassword = (e) => {
        setPassword(e.target.value)
    }

    const onChangeSaveId = () => {
        setSaveId(e => !e)
    }

    useEffect(() => {
        let obj = localStorage.getItem('saveId')
        if (obj) {
            setId(obj)
            setSaveId(true)
        }
    }, [])

    const onSubmit = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/admin/login", {
            adminId: id,
            password: password
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data

            if (tmp?.code > 0) {
                if (saveId) {
                    localStorage.setItem('saveId', id)
                }
                else {
                    localStorage.removeItem('saveId')
                }
                dispatch(change_MyData(tmp?.data?.user ?? []))
                // if (tmp?.data?.user?.role) {
                //     navigate('/dashboard')
                // }
                // else {
                //     onSubmitAuth()
                // }
                navigate(tmp?.data?.user?.role == "SUPER" ? '/dashboard' : '/paylist')
            }
            else {
                setMessage({ msg: tmp.msg })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const onSubmitAuth = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/auth/generate-otp-secret", {
            id: id
        }, {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setOtpData(tmp?.data ?? [])
                setModal(true)
            }
            else if (tmp?.code === 2001) {
                setOtpState(false)
                setOtpData(tmp?.data ?? [])
                setModal(true)
            }
            else {
                setMessage({ msg: tmp.msg })
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSubmit()
        }
    };

    return (
        <div className="login" style={{ padding: "0 2rem" }}>
            {modal && (<Authentication id={id} otpState={otpState} setModal={setModal} otpData={otpData} setMessage={setMessage} />)}
            <MessageModal message={message} />
            <div className="container sm:px-10">
                <div className="block xl:grid grid-cols-2 gap-4">
                    <div className="hidden xl:flex flex-col min-h-screen">
                        <a href="" className="-intro-x flex items-center pt-5">
                            {
                                hostLogoImg == "onu"
                                    ?
                                    <img alt="Pay K Logo" src='/img/onu.png' className="w-32" />
                                    :
                                    <img alt="Pay K Logo" src='/img/dl_logo_white.png' className="w-32" />
                            }
                        </a>
                        <div className="my-auto">
                            <img alt="Midone - HTML Admin Template" className="-intro-x w-1/2 -mt-16" src="/img/illustration.svg" />
                            <div className="-intro-x text-white font-medium text-4xl leading-tight mt-10">
                                {
                                    hostLogoImg == "onu"
                                        ?
                                        "onu"
                                        :
                                        "빠른결제대행사"
                                }  <br />
                                관리자
                            </div>
                            {/* <div className="-intro-x mt-5 text-lg text-white text-opacity-70 dark:text-slate-400">관리자 페이지</div> */}
                        </div>
                    </div>
                    <div className="h-screen xl:h-auto flex py-0 xl:py-0 my-0 xl:my-0" style={{ height: "100dvh" }}>
                        <div className="my-auto mx-auto xl:ml-20 bg-white dark:bg-darkmode-600 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto">
                            <h2 className="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
                                관리자 로그인
                            </h2>
                            <div className="intro-x mt-2 text-slate-400 xl:hidden text-center"> {
                                hostLogoImg == "onu"
                                    ?
                                    "onu"
                                    :
                                    "빠른결제대행사"
                            } - 관리자 페이지</div>
                            <div className="intro-x mt-8">
                                <form>
                                    <input type="text" id="login-id" className="intro-x login__input form-control py-3 px-4 block" placeholder="아이디" value={id} onChange={onChangeId} />
                                    <input type="password" id="login-pw" autocomplete="off" className="intro-x login__input form-control py-3 px-4 block mt-4" placeholder="패스워드" value={password} onChange={onChangePassword} onKeyDown={handleKeyPress} />
                                </form>
                            </div>
                            <div className="intro-x flex text-slate-600 dark:text-slate-500 text-xs sm:text-sm mt-4">
                                <div className="flex items-center mr-auto">
                                    <input type="checkbox" className="form-check-input border mr-2" id="saveId" checked={saveId} onChange={onChangeSaveId} />
                                    <label className="cursor-pointer select-none">아이디 저장</label>
                                </div>
                            </div>
                            <div className="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                                <button id="login-btn" className="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top" onClick={() => onSubmit()}>
                                    로그인
                                </button>
                            </div>
                            {/* <div className="intro-x mt-10 text-slate-600 dark:text-slate-500 text-center xl:text-left">
                                <div className="text-primary dark:text-slate-200" onClick={() => setModal(true)}>이용약관</div>&nbsp;&nbsp;&nbsp;
                            </div> */}
                        </div>
                    </div>
                </div>
                <div style={{ position: "fixed", bottom: "25px", left: "50%", transform: "translateX(-50%)", textAlign: "right", color: "gray", fontSize: "10px", width: "100%", maxWidth: "1920px", margin: "0 auto", paddingRight: "10px" }}>
                    <div>이 사이트는 테스트 버전으로 허가받지 않은 업체는 사용이 불가합니다.</div>
                </div>
            </div>
        </div>
    )
}

function Authentication({ id, otpState, setModal, otpData, setMessage }) {
    let navigate = useNavigate();

    // ▼ 중복 클릭 방지용
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [otp, setOTP] = useState("")
    const otpInputRef = useRef(null);

    useEffect(() => {
        otpInputRef.current?.focus();
    }, []);

    const changeOTP = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) { // 숫자만 허용
            setOTP(value);
        }
    };

    const onSubmit = async () => {
        // 이미 제출 중이면 막기
        if (isSubmitting) return;
        setIsSubmitting(true);
        console.log(id, otp)
        try {
            await axios.post(process.env.REACT_APP_API + "/api/auth/verify-otp", {
                id: id,
                token: otp
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                console.log(tmp)
                if (tmp?.code < 2000) {
                    setModal(false)
                    navigate('/dashboard')
                }
                else {
                    setMessage({ msg: tmp?.msg ?? "인증 실패" })
                }
            }).catch(error => {
                console.error(error);
            });
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div id="submerchants-modal" class="modal show_modal" tabindex="-1">
            <div className="modal-dialog">
                <div className="modal-content marginTop30 modal_sty">
                    <div className="modal-header">
                        <h2 className="font-medium mr-auto modal_title_sty">2차인증(Google Authenticator)</h2>
                        <button type="button" className="dropdown-toggle btn px-1 py-1 box modal_btn close_btn_sty" aria-expanded="false" data-tw-toggle="dropdown" onClick={() => setModal(false)}>
                            <span className="w-4 h-4 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="plus" className="lucide lucide-plus w-4 h-4" data-lucide="plus">
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "20px", padding: "20px" }}>
                        {otpState && (
                            <>
                                <QRCodeCanvas value={otpData?.qrCode ?? ""} style={{ width: '150px', height: '150px' }} />
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                                    <div>{otpData?.secret ?? ""}</div>
                                    <CopyToClipboard text={otpData?.secret ?? ""}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setMessage({ msg: "복사성공" })}>
                                            <Copy size={15} />
                                        </div>
                                    </CopyToClipboard>
                                </div>
                            </>
                        )}
                        <div>
                            <label htmlFor="인증번호" className="form-label">인증번호</label>
                            <input
                                id="인증번호"
                                name="인증번호"
                                type="text"
                                className="form-control input-padding"
                                maxLength={6}
                                value={otp}
                                onChange={changeOTP}
                                ref={otpInputRef}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onSubmit();
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="submit"
                            className="btn btn-primary w-20 reg_btn"
                            onClick={() => onSubmit()}
                            disabled={isSubmitting} // 중복클릭 방지용 비활성화
                        >
                            인증
                        </button>
                        <input
                            type="button"
                            className="btn btn-primary w-20 close_btn"
                            onClick={() => setModal(false)}
                            style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none' }}
                            value="닫기"
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Login;